<template>
  <div
    :class="{ 'has-errors': hasErrors }"
    class="form-input">
    <label
      v-if="label.length"
      :for="dropdownId"
      class="typeset-6 control-label inline-flex mb-2">
      <span v-html="label"></span>
      <span
        v-if="required"
        class="text-red">
        *
      </span>
    </label>
    <select
      :id="dropdownId"
      ref="select"
      v-model="valueToEdit"
      class="form-control"
      :class="{ 'form-control-small': small, 'text-ink-3': !valueToEdit }"
      :disabled="disabled"
      @change="$emit('update:model-value', valueToEdit)">
      <option
        v-if="includeBlank"
        value="">
        {{ placeholder }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option[valueKey]">
        {{ option[contentKey] }}
      </option>
    </select>
    <span
      v-if="hasErrors"
      class="error-box mt-2">
      {{ inputErrors.join(", ") }}
    </span>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    modelValue: {
      validator: prop =>
        typeof prop === "number" || typeof prop === "string" || prop === null,
      required: true
    },
    dropdownId: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: ""
    },
    contentKey: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    includeBlank: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:model-value"],
  data() {
    return {
      valueToEdit: this.modelValue
    };
  },
  computed: {
    inputErrors() {
      return this.errors || [];
    },
    hasErrors() {
      return this.inputErrors.length > 0;
    }
  },
  watch: {
    modelValue(value) {
      this.valueToEdit = value;
    }
  }
};
</script>
